import React from 'react';
import {
  ToolbarItem,
  SideNavLinkItemType,
} from '@amzn/aac-chrome-internal-api';
import AllToolsSideNavLink from './AllToolsSideNavLink';
import AllToolsToolbarItem from './AllToolsToolbarItem';
import AllToolsPanelButton from './AllToolsPanelButton';

interface AllToolsNavItemProps {
  toolbarItem: ToolbarItem;
}

const AllToolsNavItem: React.VFC<AllToolsNavItemProps> = ({ toolbarItem }) => {
  const isSingleApp =
    toolbarItem.sidebarGroups.length == 1 &&
    toolbarItem.sidebarGroups[0].links.length == 1;

  if (isSingleApp) {
    if (
      toolbarItem.sidebarGroups[0].links[0].sidebarItemType ===
      ('MODAL' as SideNavLinkItemType)
    ) {
      return <AllToolsPanelButton toolbarItem={toolbarItem} />;
    }
    return (
      <AllToolsSideNavLink
        key={toolbarItem.id}
        id={toolbarItem.id}
        isFromAllTools={true}
        isQuickNavModalEnabled={true}
      />
    );
  }

  return <AllToolsToolbarItem toolbarItem={toolbarItem} />;
};

export default AllToolsNavItem;
